<template>
  <div class="site-legal-banner">
    <div class="site-legal-banner__wrapper">
      <h1 class="site-legal-banner__wrapper__title">{{ props.title }}</h1>
      
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    title: String
  })
</script>
<style lang="scss">

  $desktop-breakpoint: 990px;
  $tablet-breakpoint: 672px;

  .site-legal-banner {
    background-color: #01498B;
    display: flex;
    justify-content: center;
    &__wrapper {
      flex-grow: 1;
      margin: 102px 0;
      max-width: 1200px;
      padding: 0 15px;
  
      @media screen and (min-width: $tablet-breakpoint) {
        padding: 0 30px;
      }

      &__title {
        font-weight: 600;
        font-size: 56px;
        color: white;
        text-transform: uppercase;
        margin: 0;
      }
    }
  }
</style>